import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCAdv1Page() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-4621" data-mp="1syhumd3t5y11">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-4622" data-mp="1xvrlzyarcjri">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-4623" data-mp="1o1hrob299be5">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-4624" data-mp="1eyyo1oqnauqu">
              <XIcon className="w-6 h-6" data-id="element-4625" data-mp="34c3jdx5r9xm1" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-4626" data-mp="39c7zhm2r4qbq">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-advertorial-1" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-4627" data-mp="8cdd1qfgag9f"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-4628" data-mp="3hiv70129yfj3">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-4629" data-mp="3vf8fwlsqt8ly">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-4630" data-mp="3qhqctc1epnlv" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-4631" data-mp="1drxckaxsua8i">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-4632" data-mp="1rszz0osphmjy">
        <div className="flex justify-center md:justify-between items-center" data-id="element-4633" data-mp="u4zpc41fti1p">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-4634" data-mp="u2wp6r6km8j9" />
          <div className="hidden md:block" data-id="element-4635" data-mp="18udxj8ta1tfi">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-4636" data-mp="18vgplk2c61x0">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-4637" data-mp="3v8mg409yjq8">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-4638" data-mp="3q49wwh65t2s5">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-4639" data-mp="3m1dlbaf1e6xp">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-4640" data-mp="32cl7b8kq2sew">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-4641" data-mp="3n2fddwgha0az">
        <div className="md:col-span-7" data-id="element-4642" data-mp="3s2up6jl42zqu">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-4643" data-mp="3e9vdytsd3rp3">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4644" data-mp="3i8kmo92ggl2e">
            Leer liefdevol samenwerken met je hond, zonder straffen of
            corrigeren
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-4645" data-mp="397waljwmgus5">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-4646" data-mp="tha2cvrjrn9j">
            <div className="flex -space-x-3" data-id="element-4647" data-mp="xjwu6wo7x86q">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4648" data-mp="2i28ucw1rak87" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4649" data-mp="2rtv22ievy167" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4650" data-mp="2ws6duyoqqlr2" />
            </div>
            <div data-id="element-4651" data-mp="35qicnnzrgpul">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-4652" data-mp="1gd4zd99o7rhc">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-4653" data-mp="1gf81uss0fd2y">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-4654" data-mp="3bhl7uh68zo6c">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes gebruiken voor een diepe band
            met hun hond.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-4655" data-mp="3pgcfpluiodm1">
            {['Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je probleemgedrag stopt, op een stressvrije manier (zonder corrigeren of straffen)', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je ze herkent', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-4656" data-mp="26ips7fh27du5" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-4657" data-mp="21ijtjfcdgr2k" />
                <span className="text-gray-700 font-medium" data-id="element-4658" data-mp="21kwl8k7xmfst">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-4659" data-mp="1si54c4waerts">
            <div className="flex -space-x-3" data-id="element-4660" data-mp="1sjpz9vmikcs6">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4661" data-mp="2p8nu1du9kapc" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4662" data-mp="2gdztu23jpj7e" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4663" data-mp="344vemf9l3e55" />
            </div>
            <div data-id="element-4664" data-mp="2hadgzqttmj13">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-4665" data-mp="22jxtu6huh10a">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-4666" data-mp="22hl4h89rbod7">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-4667" data-mp="2v9mvmm2dp52y">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-4668" data-mp="307675e7oz3r7">
            <div className="flex justify-center items-center w-full" data-id="element-4669" data-mp="305bwcsq4ws0u">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-advertorial-1" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-4670" data-mp="2m6vgocaanr6k"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-4671" data-mp="1h7fekmklmyxg">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4672" data-mp="1c9nmnsjyfct9">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-4673" data-mp="1ca6rc7klg4pc">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-4674" data-mp="jl88174qiwig">
            <div className="flex flex-col items-center" data-id="element-4675" data-mp="jmt3cyyvijhd">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4676" data-mp="ya4dcwfepvfd" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4677" data-mp="5s0hlise472c">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-4678" data-mp="tfcp6270z7k">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4679" data-mp="34u1up0mydo6s">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4680" data-mp="30vuatwx706rd" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4681" data-mp="2qyzf1lsb0kgs">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-4682" data-mp="2lytlg02h4nw2">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4683" data-mp="2d603fuvn7aei">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-4684" data-mp="286dnhdofjg20" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4685" data-mp="1y992hh6blqms">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-4686" data-mp="1o2zcgyj0r768">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4687" data-mp="1y2ghddqg5h15">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-4688" data-mp="1ade22cjac09t">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4689" data-mp="1fbpbim5o48ri">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-4690" data-mp="1fa4hqyr6gtup">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-4691" data-mp="mm8jhplymtvt" />
            <span className="italic" data-id="element-4692" data-mp="mmrv6ol0om1e">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-4693" data-mp="rjs0uydyfmrz">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4694" data-mp="jk42noc6x1sl">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4695" data-mp="en3xrgr2u532">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-4696" data-mp="oc5cl3lvygfg"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4697" data-mp="1h0t1d95ufnxr">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4698" data-mp="1h2x59r3qsmy1">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-4699" data-mp="1tk7yi7hi0ozm"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4700" data-mp="22is88j52zobp">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4701" data-mp="2q9fi39yk4o0w">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-4702" data-mp="17c2rij1a0buj"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-4703" data-mp="1gbg2jg51t8hd">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4704" data-mp="1cbp6oy0o025z">
              <div className="flex items-center mb-4" data-id="element-4705" data-mp="28stkhryc4p4y">
                <div className="flex text-green-500 mr-2" data-id="element-4706" data-mp="28ucytd0fkq43">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4707" data-mp="2408t0x2wio4l" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4708" data-mp="3mrg06tp5h2o7">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4709" data-mp="3rqailuj7gp7s">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4710" data-mp="4krvh4y0ihj2">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4711" data-mp="x8xdvl1lfufq">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4712" data-mp="2t8xtpi8wscp2">
              <div className="flex items-center mb-4" data-id="element-4713" data-mp="2oa4hdt5cyrqh">
                <div className="flex text-green-500 mr-2" data-id="element-4714" data-mp="33259zy56td3x">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4715" data-mp="2y9ll4511uvjt" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4716" data-mp="3c074duuf17i8">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4717" data-mp="37zewb4xa58nj">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4718" data-mp="3lz6e7gqx396t">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4719" data-mp="3tjgz1fkcpwe4">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4720" data-mp="3fio8t7131ngt">
              <div className="flex items-center mb-4" data-id="element-4721" data-mp="3kj2c6brqo98i">
                <div className="flex text-green-500 mr-2" data-id="element-4722" data-mp="3kgfxztacevhb">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4723" data-mp="3akmoyjvu1k4a" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4724" data-mp="13uetu7tkile3">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4725" data-mp="18szsw3x32z0y">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4726" data-mp="3sohb8v8cy37w">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4727" data-mp="2v3ms7u5d98nh">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4728" data-mp="t9ng56kf6n9q">
              <div className="flex items-center mb-4" data-id="element-4729" data-mp="10ty0l49xz8gi">
                <div className="flex text-green-500 mr-2" data-id="element-4730" data-mp="10t4zojxnzd6a">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4731" data-mp="15qofvpdxa00v" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4732" data-mp="1altzghjur2ls">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4733" data-mp="1fkncy9z52tly">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4734" data-mp="mt3puezf8veo">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4735" data-mp="wtnu7qi8mg14">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4736" data-mp="286qb6mo917lt">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-4737" data-mp="3scfj3iwzjxng">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-4738" data-mp="3sdqlbeas8xcg">
          <div data-id="element-4739" data-mp="9od0qitlhwf">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4740" data-mp="2zmp1v1024fn4">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-4741" data-mp="34mbou25ota94">
              <p data-id="element-4742" data-mp="38n3y2vek7f5e">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-4743" data-mp="suehw88dltts">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-4744" data-mp="p7q72p0gtsze">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-4745" data-mp="24oi4fnczzvu1">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-4746" data-mp="3l68v4pov76fx">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-4747" data-mp="lqvbv2koo5va">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-4748" data-mp="lq2f8uffuwqv" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-4749" data-mp="2sjo3rp8e2ucd">
        <div className="max-w-md mx-auto px-4" data-id="element-4750" data-mp="2xgo6pr9xzgz9">
          <div className="p-6 rounded-3xl w-full" data-id="element-4751" data-mp="2xebkh1x5ikge">
            <div className="flex justify-center items-center" data-id="element-4752" data-mp="2oycjkytnlhqp">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-advertorial-1" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-4753" data-mp="2kxsm1u564c41"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-4754" data-mp="2fzh9vcrehpin">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-4755" data-mp="2b7h95i3iasl0">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-4756" data-mp="1ni4wg88z02dy" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-4757" data-mp="lt85fkwipkui">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-4758" data-mp="qr9kluqtp00p">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-4759" data-mp="zkwd9bzqhn5o">
            <p className="mb-2" data-id="element-4760" data-mp="14j7q7vlbsds4">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-4761" data-mp="19g7sdvf20wdy">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-4762" data-mp="37xi06vo2b1bt" />
    </div>;
}